export default "__VITE_ASSET__CkPbuZuM__"